// packages/app/src/app/shared/transaction/all-transaction/transaction-history-table/table-row-action-with-delete.tsx
"use client";

import React from "react";
import EyeIcon from "@core/components/icons/eye";
import PencilIcon from "@core/components/icons/pencil";
import { ActionIcon, Flex, Tooltip } from "rizzui";
import { Link } from "react-router-dom";
import cn from "@core/utils/class-names";
import DeletePopover from "../../components/delete-popover";

export default function TableRowActionGroupWithDelete({
  onDelete,
  editUrl = null,
  viewUrl = "#",
  deletePopoverTitle = "Delete the payment",
  deletePopoverDescription = "Are you sure you want to delete this payment item?",
  className,
}: {
  onDelete?: () => void;
  editUrl?: string | null;
  viewUrl?: string;
  deletePopoverTitle?: string;
  deletePopoverDescription?: string;
  className?: string;
}) {
  return (
    <Flex
      align="center"
      justify="end"
      gap="3"
      className={cn("pe-3", className)}
    >
      {editUrl && (
        <Tooltip size="sm" content="Edit Item" placement="top" color="invert">
          <span>
            <Link to={editUrl}>
              <ActionIcon
                as="span"
                size="sm"
                variant="outline"
                aria-label="Edit Item"
              >
                <PencilIcon className="size-4" />
              </ActionIcon>
            </Link>
          </span>
        </Tooltip>
      )}

      <Tooltip size="sm" content="View Payment" placement="top" color="invert">
        <span>
          <Link to={viewUrl}>
            <ActionIcon
              as="span"
              size="sm"
              variant="outline"
              aria-label="View item"
            >
              <EyeIcon className="size-4" />
            </ActionIcon>
          </Link>
        </span>
      </Tooltip>

      <Tooltip
        size="sm"
        content="Delete Payment"
        placement="top"
        color="invert"
      >
        <span>
          <DeletePopover
            title={deletePopoverTitle}
            description={deletePopoverDescription}
            onDelete={onDelete}
          />
        </span>
      </Tooltip>
    </Flex>
  );
}
